import router from "@/global-config/router/routes-registration/route";


router.beforeEach((to, from, next) => {
    if (to.path == '/') {
        next('merchant-payment-form');
    } else {
        next();
    }

})
